import { Dispatch, SetStateAction } from 'react';
import { DialogInOne } from 'src/components';
import CloseBtn from 'src/components/DialogWithOuterBox/components/CloseBtn';
import { Box, Button, Typography } from 'src/components/MuiGenerals';
import { useListMappingTransform, useTranslation } from 'src/hooks';
import { downloadFiles } from 'src/utils';
import { ApiResponse } from '../../types/ApiResponse';
import useTableRows from './hook/useTableRows';
import { Preview } from '../../types/Preview';

type Props = {
  isOpen: boolean;
  validPreviews: Preview[];
  apiResponses: ApiResponse[];
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  clearData: () => void;
};

const ExportResultDialog = (props: Props) => {
  const { isOpen, validPreviews, apiResponses, setIsOpen, clearData } = props;
  const { t } = useTranslation('clientCreditAllocation');

  const listMappingTransform = useListMappingTransform('export');

  const { mapResultToTupleArray } = useTableRows({
    validPreviews,
    apiResponses,
  });

  const numberOfSuccess = apiResponses.filter((item) => item.result).length;
  const numberOfFailed = apiResponses.filter((item) => !item || !item.result).length;

  const onClose = () => {
    setIsOpen(false);
    clearData();
  };

  const onExport = () => {
    const res = mapResultToTupleArray();
    const output = res.map(listMappingTransform);
    downloadFiles('Export_Allocate_Credit_Request', output, {});
  };

  return (
    <DialogInOne
      self={{
        open: isOpen,
        onClose: () => {},
      }}
      size="sm"
      content={
        <Box>
          <CloseBtn
            sx={{
              top: '12px',
              right: '12px',
              color: 'white',
              fontSize: '16px',
            }}
            handleClick={onClose}
          />
          <Typography variant="h6" children={t('successfullyCreateRecords', { numberOfSuccess })} />
          <Typography variant="h6" children={t('failedToCreateRecords', { numberOfFailed })} />
          <Box display={'flex'} justifyContent={'center'} padding={'1rem 0'}>
            <Button
              className={'inheritColor'}
              color={'primary'}
              variant={'contained'}
              children={t('exportCreationDetail')}
              onClick={onExport}
            />
          </Box>
        </Box>
      }
      title={''}
      isConfirmHidden
      isCancelHidden
      onConfirm={() => {}}
      onCancel={() => {}}
    />
  );
};
export default ExportResultDialog;
